import { useMemo } from 'react';

import { useCurrentJob } from 'hooks';

import { getEtikaCreditLine } from './helpers';

import type { FormattedRates } from '../constants';

export interface PreApprovalMessageHook {
  showMessage: boolean;
  creditLine: number;
}

export default function usePreApprovalMessage(
  rates: FormattedRates | [],
): PreApprovalMessageHook {
  const { job } = useCurrentJob();

  const jobTotal = useMemo(
    () => job?.total?.amount_vat_inclusive?.amount || 0,
    [job],
  );

  const creditLine = useMemo(() => getEtikaCreditLine(rates), [rates]);

  const showMessage = useMemo(() => creditLine > 0, [creditLine]);

  return {
    showMessage,
    creditLine: jobTotal === 0 ? creditLine : Math.min(jobTotal, creditLine),
  };
}
